import React from 'react';
import { withBlockExtensions } from '@plone/volto/helpers';
import {
  AcoesRapidasCard,
  type AcoesRapidasData,
} from 'volto-ministerio-publico-federal/components/View/CapaView/AcoesRapidasCard';

interface MpfAcoesRapidasBlockViewProps {
  data: AcoesRapidasData & { placeholder?: string };
  onEditItem?: (index: number) => void;
}

/** Bloco "Ações rápidas (capa)" — o card "O que você deseja fazer hoje?". */
const MpfAcoesRapidasBlockView = ({
  data,
  onEditItem,
}: MpfAcoesRapidasBlockViewProps) => (
  <>
    <AcoesRapidasCard data={data} onEditItem={onEditItem} />
    {!data?.links?.length && data?.placeholder && (
      <p className="mt-2 text-sm text-gray-500 dark:text-night-400">
        {data.placeholder}
      </p>
    )}
  </>
);

export default withBlockExtensions(MpfAcoesRapidasBlockView);
